import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import { ToastContext } from "@aleaplay/web-components/ui/Toast";

import App from "@/App";
import I18nProvider from "@/v1/i18n/I18nProvider";
import rootReducer from "@/v1/store/rootReducer";
import { checkSession } from "@/v2/utils/checkSession";

import { configureApm } from "./v2/utils/configureApm";

checkSession();

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

ReactDOM.render(
  <Provider store={store}>
    <I18nProvider>
      <ToastContext>
        <App />
      </ToastContext>
    </I18nProvider>
  </Provider>,
  document.getElementById("root"),
);

// Delayed initialization of Alea APM
// to ensure it runs after the main app has loaded
if ("requestIdleCallback" in window) {
  window.requestIdleCallback(configureApm);
} else {
  setTimeout(configureApm, 500);
}
